import React, { useState, useEffect } from "react";
import { login, loginSSO, saveTokens, saveUser } from "../api";

const LoginPage = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Listen for SSO success message from the callback window
    useEffect(() => {
        const handleMessage = (event) => {
            const msg = event.data?.pluginMessage;
            if (msg?.type === "AUTH_SUCCESS") {
                const { tokens, user, org_id } = msg.payload;
                saveTokens(tokens.access_token, tokens.refresh_token);
                saveUser({ user_id: user.user_id || user.email }, org_id);
                onLogin?.();
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [onLogin]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !password) { setError("Please enter your email and password."); return; }
        setLoading(true);
        setError("");
        try {
            await login(email.trim(), password);
            onLogin?.();
        } catch (err) {
            setError(err.message || "Login failed. Please check your credentials.");
        } finally {
            setLoading(false);
        }
    };

    const handleSSO = async () => {
        if (!email) { setError("Please enter your email for SSO."); return; }
        setLoading(true);
        setError("");
        try {
            const res = await loginSSO(email.trim());
            if (res.redirect_url) {
                // Open SSO in a popup
                window.open(res.redirect_url, "sso_login", "width=600,height=700");
            } else {
                setError("SSO redirect URL missing.");
            }
        } catch (err) {
            setError(err.message || "SSO initiation failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="cr-login-wrapper">
            <div className="cr-login-card">
                {/* Logo */}
                <img src="/assets/logo.svg" alt="Fairpatterns" className="cr-login-logo"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                    }} />

                <h1 className="cr-login-title">Dark Pattern Review Portal</h1>
                <p className="cr-login-subtitle">
                    Sign in to review dark pattern analysis sessions
                </p>

                <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
                    <div className="cr-form-group" style={{ marginBottom: 16 }}>
                        <label className="cr-form-label">Email</label>
                        <input
                            className="cr-form-input"
                            type="email"
                            placeholder="you@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            disabled={loading}
                        />
                    </div>

                    <div className="cr-form-group" style={{ marginBottom: 24 }}>
                        <label className="cr-form-label">Password</label>
                        <input
                            className="cr-form-input"
                            type="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            disabled={loading}
                        />
                    </div>

                    <button
                        type="submit"
                        className="cr-google-btn"
                        disabled={loading}
                        style={{
                            justifyContent: "center", background: "var(--accent)", color: "#fff",
                            border: "none", fontWeight: 700, width: "100%", padding: "12px",
                            borderRadius: "8px", marginBottom: "16px"
                        }}
                    >
                        {loading ? "Signing in…" : "Sign in with Email"}
                    </button>
                    
                    <div style={{ display: "flex", alignItems: "center", margin: "16px 0" }}>
                        <div style={{ flex: 1, height: "1px", background: "#e0e0e0" }}></div>
                        <span style={{ margin: "0 10px", color: "#666", fontSize: "14px", fontWeight: "500" }}>OR</span>
                        <div style={{ flex: 1, height: "1px", background: "#e0e0e0" }}></div>
                    </div>

                    <button
                        type="button"
                        onClick={handleSSO}
                        className="cr-google-btn"
                        disabled={loading}
                        style={{
                            justifyContent: "center", background: "#f8f9fa", color: "#333",
                            border: "1px solid #ddd", fontWeight: 700, width: "100%", padding: "12px",
                            borderRadius: "8px"
                        }}
                    >
                        Sign in with SSO
                    </button>
                </form>

                {error && <div className="cr-login-error" style={{ marginTop: "16px" }}>{error}</div>}
            </div>
        </div>
    );
};

export default LoginPage;

